import { Pictures } from './components/Pictures';
import { TakingActionBody } from './components/TakingActionBody';

export function TakingAction() {
	return (
		<div className="bg-fill-inverse-weak py-20">
			<div className="container">
				<div className="flex flex-col items-center justify-center gap-8">
					<TakingActionBody />
					<Pictures />
				</div>
			</div>
		</div>
	);
}
